import { createContext, useContext, useState, useEffect } from "react";

const translations = {
  en: {
    // Header
    services: "Services",
    fleet: "Fleet",
    corporate: "Corporate",
    contact: "Contact",
    bookNow: "Book Now",
    // Hero
    premiumChauffeurService: "Premium Chauffeur Service",
    heroHeadline: "Your Premium Chauffeur Service in Saudi Arabia",
    heroSubheadline: "Reliable airport transfers, hourly rides, and corporate travel across Riyadh, Jeddah, and all of KSA.",
    available247: "24/7 Available",
    allMajorCities: "All Major Cities",
    // Booking Widget
    bookYourRide: "Book Your Ride",
    fastSimplePremium: "Fast, simple, premium.",
    pickupLocation: "Pickup location",
    dropoffLocation: "Drop-off location",
    date: "Date",
    time: "Time",
    vehicleType: "Vehicle type",
    firstClass: "First Class",
    eliteSuv: "Elite SUV",
    business: "Business",
    executive: "Executive",
    group: "Group",
    standard: "Standard",
    // Trust
    whyBlackRide: "Why BlackRide",
    whyChooseBlackRide: "Why Choose BlackRide",
    professionalChauffeurs: "Professional Chauffeurs",
    professionalChauffeursDesc: "Vetted, trained, and licensed drivers ensuring a safe, premium experience.",
    onTimeGuarantee: "On-Time Guarantee",
    onTimeGuaranteeDesc: "Punctuality is our promise. We track every ride to ensure timely arrivals.",
    transparentPricing: "Transparent Pricing",
    transparentPricingDesc: "No hidden fees. Clear, upfront pricing for every journey.",
    support247: "24/7 Support",
    support247Desc: "Round-the-clock assistance for bookings, changes, and inquiries.",
    liveTracking: "Live Tracking",
    liveTrackingDesc: "Track your ride in real-time for complete peace of mind.",
    // Services
    ourServices: "Our Services",
    tailoredForEveryJourney: "Tailored For Every Journey",
    airportTransfers: "Airport Transfers",
    airportTransfersDesc: "Seamless pickups and drop-offs at all major Saudi airports. Flight tracking included.",
    bookTransfer: "Book Transfer",
    hourlyChauffeur: "Hourly Chauffeur",
    hourlyChauffeurDesc: "Your personal driver for meetings, events, or city exploration. Book by the hour.",
    bookHourly: "Book Hourly",
    corporateTravel: "Corporate Travel",
    corporateTravelDesc: "Dedicated fleet management for enterprises. Monthly billing and priority service.",
    learnMore: "Learn More",
    umrahZiyarat: "Umrah & Ziyarat",
    umrahZiyaratDesc: "Comfortable, reliable transport between holy sites. Experienced drivers who know the routes.",
    bookTransport: "Book Transport",
    // How It Works
    howItWorks: "How It Works",
    threeSimpleSteps: "Three Simple Steps",
    step: "STEP",
    bookYourRideStep: "Book Your Ride",
    bookYourRideStepDesc: "Choose your pickup, destination, and vehicle class in seconds.",
    getMatched: "Get Matched",
    getMatchedDesc: "We assign your nearest professional chauffeur instantly.",
    enjoyTheJourney: "Enjoy the Journey",
    enjoyTheJourneyDesc: "Sit back and relax in a premium vehicle with a world-class driver.",
    // Vehicle Classes
    ourFleet: "Our Fleet",
    vehicleClasses: "Vehicle Classes",
    firstClassDesc: "BMW 735i. The pinnacle of luxury and executive travel.",
    eliteSuvDesc: "GMC Yukon XL. Spacious premium SUV for ultimate comfort.",
    businessDesc: "Lexus ES. Refined elegance for business professionals.",
    executiveDesc: "Mercedes Vito. Spacious executive transport for groups.",
    groupDesc: "Toyota Hiace. Comfortable group transport for up to 12 passengers.",
    standardDesc: "Toyota Camry. Reliable and comfortable for everyday transfers.",
    upTo: "Up to",
    bags: "bags",
    // Corporate
    forBusiness: "For Business",
    businessTravelMadeSimple: "Business Travel Made Simple",
    corporateDesc: "Streamline your company's ground transportation with BlackRide's corporate solutions. One platform for all your team's travel needs.",
    monthlyBilling: "Monthly billing & invoicing",
    dedicatedAccountManager: "Dedicated account manager",
    priorityFleetAccess: "Priority fleet access",
    customRidePolicies: "Custom ride policies",
    realtimeReporting: "Real-time reporting dashboard",
    contactSales: "Contact Sales",
    // Testimonials
    testimonials: "Testimonials",
    whatOurClientsSay: "What Our Clients Say",
    // CTA
    readyToRide: "Ready to ride?",
    bookYourPremiumRideNow: "Book Your Premium Ride Now",
    ctaDesc: "Experience luxury ground transportation across Saudi Arabia. Available 24/7.",
    exploreFleet: "Explore Fleet",
    // Footer
    footerDesc: "Premium chauffeur service across Saudi Arabia. Experience luxury ground transportation with professional drivers and world-class vehicles.",
    aboutUs: "About Us",
    ourFleetLink: "Our Fleet",
    careers: "Careers",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    refundPolicy: "Refund Policy",
    company: "Company",
    legal: "Legal",
    allRightsReserved: "All rights reserved.",
    // Booking fields for WhatsApp
    customerName: "Your name",
    customerPhone: "Phone number",
    customerEmail: "Email address",
    notes: "Additional notes",
   //Added for Blog and Explore pages
explore: "Explore",
blog: "Blog",
jeddahChauffeurService: "Jeddah Chauffeur Service",
blogTitle: "BlackRide Blog",
blogSubtitle: "Travel tips, chauffeur insights, airport transfer guidance, and updates from BlackRide.",
jeddahServiceTitle: "Chauffeur Service in Jeddah",
jeddahServiceSubtitle: "Premium airport transfers, business travel, private city rides, and luxury transportation in Jeddah.",
bookChauffeurService: "Book Chauffeur Service",
readTravelGuides: "Read Travel Guides",
bookNowOnBlackRide: "Book Now on BlackRide",
backToBlog: "Back to Blog",
  },
  ar: {
    // Header
    services: "الخدمات",
    fleet: "الأسطول",
    corporate: "الشركات",
    contact: "اتصل بنا",
    bookNow: "احجز الآن",
    // Hero
    premiumChauffeurService: "خدمة سائق خاص متميزة",
    heroHeadline: "خدمة السائق الخاص المتميزة في المملكة العربية السعودية",
    heroSubheadline: "توصيل موثوق من وإلى المطار، رحلات بالساعة، وسفر الشركات في الرياض وجدة وجميع أنحاء المملكة.",
    available247: "متاح 24/7",
    allMajorCities: "جميع المدن الرئيسية",
    // Booking Widget
    bookYourRide: "احجز رحلتك",
    fastSimplePremium: "سريع، بسيط، متميز.",
    pickupLocation: "موقع الاستلام",
    dropoffLocation: "موقع التوصيل",
    date: "التاريخ",
    time: "الوقت",
    vehicleType: "نوع المركبة",
    firstClass: "الدرجة الأولى",
    eliteSuv: "SUV فاخر",
    business: "أعمال",
    executive: "تنفيذي",
    group: "مجموعة",
    standard: "عادي",
    // Trust
    whyBlackRide: "لماذا بلاك رايد",
    whyChooseBlackRide: "لماذا تختار بلاك رايد",
    professionalChauffeurs: "سائقون محترفون",
    professionalChauffeursDesc: "سائقون معتمدون ومدربون ومرخصون يضمنون تجربة آمنة ومتميزة.",
    onTimeGuarantee: "ضمان الوصول في الموعد",
    onTimeGuaranteeDesc: "الالتزام بالمواعيد وعدنا. نتتبع كل رحلة لضمان الوصول في الوقت المحدد.",
    transparentPricing: "أسعار شفافة",
    transparentPricingDesc: "لا رسوم خفية. أسعار واضحة ومحددة مسبقاً لكل رحلة.",
    support247: "دعم 24/7",
    support247Desc: "مساعدة على مدار الساعة للحجوزات والتغييرات والاستفسارات.",
    liveTracking: "تتبع مباشر",
    liveTrackingDesc: "تتبع رحلتك في الوقت الفعلي لراحة بالك التامة.",
    // Services
    ourServices: "خدماتنا",
    tailoredForEveryJourney: "مصممة لكل رحلة",
    airportTransfers: "التوصيل من وإلى المطار",
    airportTransfersDesc: "استقبال وتوصيل سلس في جميع المطارات السعودية الرئيسية. تتبع الرحلات الجوية متضمن.",
    bookTransfer: "احجز التوصيل",
    hourlyChauffeur: "سائق بالساعة",
    hourlyChauffeurDesc: "سائقك الشخصي للاجتماعات والمناسبات واستكشاف المدينة. احجز بالساعة.",
    bookHourly: "احجز بالساعة",
    corporateTravel: "سفر الشركات",
    corporateTravelDesc: "إدارة أسطول مخصصة للمؤسسات. فواتير شهرية وخدمة ذات أولوية.",
    learnMore: "اعرف المزيد",
    umrahZiyarat: "العمرة والزيارة",
    umrahZiyaratDesc: "نقل مريح وموثوق بين المواقع المقدسة. سائقون ذوو خبرة يعرفون الطرق.",
    bookTransport: "احجز النقل",
    // How It Works
    howItWorks: "كيف يعمل",
    threeSimpleSteps: "ثلاث خطوات بسيطة",
    step: "خطوة",
    bookYourRideStep: "احجز رحلتك",
    bookYourRideStepDesc: "اختر نقطة الاستلام والوجهة وفئة المركبة في ثوانٍ.",
    getMatched: "يتم تعيين سائق",
    getMatchedDesc: "نعين لك أقرب سائق محترف فوراً.",
    enjoyTheJourney: "استمتع بالرحلة",
    enjoyTheJourneyDesc: "استرخِ واستمتع في مركبة متميزة مع سائق عالمي المستوى.",
    // Vehicle Classes
    ourFleet: "أسطولنا",
    vehicleClasses: "فئات المركبات",
    firstClassDesc: "BMW 735i. قمة الفخامة والسفر التنفيذي.",
    eliteSuvDesc: "GMC Yukon XL. سيارة SUV فاخرة وواسعة لأقصى درجات الراحة.",
    businessDesc: "Lexus ES. أناقة راقية لرجال الأعمال.",
    executiveDesc: "Mercedes Vito. نقل تنفيذي واسع للمجموعات.",
    groupDesc: "Toyota Hiace. نقل مجموعات مريح لما يصل إلى 12 راكباً.",
    standardDesc: "Toyota Camry. موثوقة ومريحة للتنقلات اليومية.",
    upTo: "حتى",
    bags: "حقائب",
    // Corporate
    forBusiness: "للشركات",
    businessTravelMadeSimple: "سفر الأعمال أصبح بسيطاً",
    corporateDesc: "بسّط النقل البري لشركتك مع حلول بلاك رايد للشركات. منصة واحدة لجميع احتياجات سفر فريقك.",
    monthlyBilling: "فواتير شهرية",
    dedicatedAccountManager: "مدير حساب مخصص",
    priorityFleetAccess: "وصول ذو أولوية للأسطول",
    customRidePolicies: "سياسات رحلات مخصصة",
    realtimeReporting: "لوحة تقارير في الوقت الفعلي",
    contactSales: "تواصل مع المبيعات",
    // Testimonials
    testimonials: "آراء العملاء",
    whatOurClientsSay: "ماذا يقول عملاؤنا",
    // CTA
    readyToRide: "جاهز للرحلة؟",
    bookYourPremiumRideNow: "احجز رحلتك المتميزة الآن",
    ctaDesc: "اختبر النقل البري الفاخر في جميع أنحاء المملكة العربية السعودية. متاح 24/7.",
    exploreFleet: "استكشف الأسطول",
    // Footer
    footerDesc: "خدمة سائق خاص متميزة في جميع أنحاء المملكة العربية السعودية. اختبر النقل البري الفاخر مع سائقين محترفين ومركبات عالمية المستوى.",
    aboutUs: "من نحن",
    ourFleetLink: "أسطولنا",
    careers: "الوظائف",
    privacyPolicy: "سياسة الخصوصية",
    termsOfService: "شروط الخدمة",
    refundPolicy: "سياسة الاسترداد",
    company: "الشركة",
    legal: "قانوني",
    allRightsReserved: "جميع الحقوق محفوظة.",
    // Booking
    customerName: "اسمك",
    customerPhone: "رقم الهاتف",
    customerEmail: "البريد الإلكتروني",
    notes: "ملاحظات إضافية",
// For Blog and Explore section
explore: "استكشف",
blog: "المدونة",
jeddahChauffeurService: "خدمة السائق الخاص في جدة",
blogTitle: "مدونة بلاك رايد",
blogSubtitle: "نصائح السفر، ورؤى خدمات السائق الخاص، وإرشادات التنقل من وإلى المطار، وآخر التحديثات من بلاك رايد.",
jeddahServiceTitle: "خدمة السائق الخاص في جدة",
jeddahServiceSubtitle: "خدمات نقل فاخرة من وإلى المطار، وسفر الأعمال، والتنقلات الخاصة داخل المدينة، والمواصلات الفاخرة في جدة.",
bookChauffeurService: "احجز خدمة السائق",
readTravelGuides: "اقرأ أدلة السفر",
bookNowOnBlackRide: "احجز الآن عبر بلاك رايد",
backToBlog: "العودة إلى المدونة",
  },
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("blackride-lang") || "en");

  useEffect(() => {
    localStorage.setItem("blackride-lang", lang);
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => translations[lang]?.[key] || translations.en[key] || key;
  const toggleLang = () => setLang((prev) => (prev === "en" ? "ar" : "en"));
  const isRTL = lang === "ar";

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, toggleLang, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
